import React from 'react';
import classNames from 'classnames';
import intl from 'react-intl-universal';
import Button from 'src/ui/library/Button';
import EditIcon from '@material-ui/icons/Edit';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import ContentParser from 'src/ui/library/ContentParser';
import Spinner from 'src/ui/library/Spinner/Spinner';

export default function CaseAdditionalInformationPres(props) {
  const {
    showModal,
    formDetails,
    isActionBarHidden,
    onFormChange,
    onCancelModal,
    onConfirmModal,
    isCorpClientLineManager,
    isLoading,
    isActive,
    isEditable,
    onCancel,
    onSave,
    onEdit,
  } = props;

  if (isLoading || !formDetails.case)
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );
  if (!formDetails.case.pageElements)
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );

  const formClass = classNames({
    'cases-form-detail': true,
    editmode: isEditable,
  });

  const wrapperFormDivClass = classNames({
    'detail-body-inner': true,
  });

  const numberOfColumns = isEditable ? 4 : 3;

  return (
    <React.Fragment>
      <div style={{ display: isActive ? '' : 'none' }}>
        {showModal && (
          <ConfirmDialog
            open
            title={intl.get('cases.details.messages.cancelTitle')}
            cancelText={intl.get('cases.details.buttons.cancelEdit')}
            confirmText={intl.get('cases.details.buttons.continueEdit')}
            onCancel={onCancelModal}
            onConfirm={onConfirmModal}>
            {intl.get('cases.details.messages.confirmMessage')}
          </ConfirmDialog>
        )}
        <div className={wrapperFormDivClass}>
          <section className={formClass}>
            {!isCorpClientLineManager ? (
              <div className="form-parser">
                <ContentParser
                  key={isEditable}
                  readOnly={!isEditable}
                  data={formDetails.case}
                  numberOfColumns={numberOfColumns}
                  showLabels={false}
                  debug={false}
                  onChange={onFormChange}
                />
              </div>
            ) : null}
          </section>
        </div>

        {!isActionBarHidden && !isCorpClientLineManager ? (
          <section className="cases-actions formdetail">
            {isEditable ? (
              <div className="button-wrapper">
                <Button styleType="secondary" onClick={onCancel} className="action-button">
                  {intl.get('cases.details.buttons.cancel')}
                </Button>
                <Button className="action-button" onClick={onSave}>
                  {intl.get('cases.details.buttons.save')}
                </Button>
              </div>
            ) : (
              <a className="edit-link" onClick={onEdit}>
                <EditIcon className="edit-icon" /> <span className="edit-text">{intl.get('cases.details.buttons.editDetails')}</span>
              </a>
            )}
          </section>
        ) : null}
      </div>
    </React.Fragment>
  );
}
